const routes_ari = [
    {
        path: '/inicio',
        component: resolve => require(['../../containers/DefaultContainer.vue'], resolve),
        children: [
            {
                path: '/analisis-de-riesgos/analisis/formulario/:id?/:id_empresa?',
                component: resolve => require(['../../views/risk_analysis/analysis/form.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Análisis',
                    permiso: ['modulo-analisis-riesgos-formulario'],
                    breadcrumb: '/analisis-de-riesgos/tareas',
                }
            },
            {
                path: '/analisis-de-riesgos/analisis',
                component: resolve => require(['../../views/risk_analysis/analysis/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Análisis',
                    permiso: ['modulo-analisis-riesgos-analisis'],
                    breadcrumb: '/analisis-de-riesgos/tareas',
                }
            },
            {
                path: '/analisis-de-riesgos/fichas-de-control/formulario/:id_tarea/:id_empresa',
                component: resolve => require(['../../views/risk_analysis/analysis/control_sheets.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Fichas de control',
                    permiso: ['modulo-analisis-riesgos-fichas-de-control'],
                    breadcrumb: '/analisis-de-riesgos/fichas-de-control',
                }
            },
            {
                path: '/analisis-de-riesgos/tareas',
                component: resolve => require(['../../views/risk_analysis/tasks/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Tareas',
                    permiso: ['modulo-analisis-riesgos-tareas'],
                    breadcrumb: '/analisis-de-riesgos/tareas',
                }
            },
            {
                path: '/analisis-de-riesgos/fichas-de-control',
                component: resolve => require(['../../views/risk_analysis/control_sheets/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Fichas de control',
                    permiso: ['modulo-analisis-riesgos-fichas-de-control'],
                    breadcrumb: '/analisis-de-riesgos/fichas-de-control',
                }
            },
            {
                path: '/analisis-de-riesgos/graficas',
                component: resolve => require(['../../views/risk_analysis/charts/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Fichas de control',
                    permiso: ['modulo-analisis-riesgos-graficas'],
                    breadcrumb: '/analisis-de-riesgos/graficas',
                }
            },
            {
                path: '/analisis-de-riesgos/configuraciones-generales',
                component: resolve => require(['../../views/risk_analysis/config_concepts/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Configuraciones',
                    permiso: ['analisis-riesgos-configuraciones-concepto'],
                    breadcrumb: '/analisis-de-riesgos/configuraciones-generales',
                }
            },
        ]
    }
];

export default routes_ari;
